import Browser from './browser'
export default Browser



// WEBPACK FOOTER //
// ./src/components/browser/index.js